import React from 'react';
import { Tooltip } from '@mantine/core';
import type { DeckAssessmentDotStatus } from '../../../utils/notesOcr';

type Props = {
  status: DeckAssessmentDotStatus;
  tooltip: string;
  onClick?: () => void;
};

const COLORS: Record<Exclude<DeckAssessmentDotStatus, 'not_applicable'>, string> = {
  pending: '#9ca3af',
  in_progress: '#f59e0b',
  failed: '#dc3c3d',
  ok: '#12b76a',
  needs_fix: '#dc3c3d',
};

const DeckAssessmentDot: React.FC<Props> = ({ status, tooltip, onClick }) => {
  if (status === 'not_applicable') {
    return <span style={{ width: '1rem', height: '1rem', display: 'inline-block' }} />;
  }

  const clickable = Boolean(onClick);

  return (
    <Tooltip label={tooltip} withArrow arrowSize={6} multiline maw={280}>
      <span
        role={clickable ? 'button' : undefined}
        tabIndex={clickable ? 0 : undefined}
        onClick={clickable ? onClick : undefined}
        onKeyDown={
          clickable
            ? (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  onClick?.();
                }
              }
            : undefined
        }
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          cursor: clickable ? 'pointer' : 'help',
        }}
      >
        <span
          style={{
            width: '1rem',
            height: '1rem',
            borderRadius: '50%',
            backgroundColor: COLORS[status],
          }}
        />
      </span>
    </Tooltip>
  );
};

export default DeckAssessmentDot;
